/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Create_Company_User_Change_EmailInputs */

const en_admin_create_company_user_change_email = /** @type {(inputs: Admin_Create_Company_User_Change_EmailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Change email`)
};

const de_admin_create_company_user_change_email = /** @type {(inputs: Admin_Create_Company_User_Change_EmailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`E-Mail-Adresse ändern`)
};

/**
* | output |
* | --- |
* | "Change email" |
*
* @param {Admin_Create_Company_User_Change_EmailInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const admin_create_company_user_change_email = /** @type {((inputs?: Admin_Create_Company_User_Change_EmailInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Create_Company_User_Change_EmailInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_admin_create_company_user_change_email(inputs)
	return en_admin_create_company_user_change_email(inputs)
});